<div class="content">
  <div class="card navigation" *ngIf="!mobile">
    <!-- <app-image [fileid]="self?.avatar" [radius]="40"></app-image> -->
    <app-user-avatar [fileid]="self?.avatar" size="80px"></app-user-avatar>

    <h1>{{ self?.nickname || " " }}</h1>

    <div class="links">
      <button
        mat-menu-item
        routerLink="/user/profile"
        matRipple
        matRippleColor="#01c6b41c"
        [ngClass]="{ active: router.url === '/user/profile' }"
      >
        <mat-icon>account_circle</mat-icon>
        <span>个人资料</span>
      </button>
      <button
        mat-menu-item
        routerLink="/user/profile/seats"
        matRipple
        matRippleColor="#01c6b41c"
        [ngClass]="{ active: router.url === '/user/profile/seats' }"
      >
        <mat-icon>local_activity</mat-icon> <span>我的车票</span>
      </button>
      <button
        mat-menu-item
        routerLink="/user/profile/affiliate"
        matRipple
        matRippleColor="#01c6b41c"
        [ngClass]="{ active: router.url === '/user/profile/affiliate' }"
      >
        <mat-icon>share</mat-icon> <span>我的推广</span>
      </button>
      <button
        mat-menu-item
        routerLink="/user/profile/orders"
        matRipple
        matRippleColor="#01c6b41c"
        [ngClass]="{ active: router.url === '/user/profile/orders' }"
      >
        <mat-icon>receipt_long</mat-icon> <span>订单记录</span>
      </button>

      <button
        mat-menu-item
        routerLink="/user/profile/form"
        matRipple
        matRippleColor="#01c6b41c"
        [ngClass]="{ active: router.url.includes('/user/profile/form') }"
      >
        <mat-icon>description</mat-icon>
        <span style="display: flex; align-items: center"
          >我的工单
          <span
            *ngIf="workorderNotificationCount > 0"
            style="
              margin-left: 10px;
              display: inline-block;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: red;
            "
          ></span
        ></span>
      </button>

      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon> 退出登录
      </button>
    </div>
  </div>

  <div class="router"><router-outlet></router-outlet></div>
</div>
